/** Persists last /demo/:chapter so /nova and /nova-chat can render chapter-scoped nav (DashboardNav). */
export const DEMO_NAV_CHAPTER_KEY = 'orivonDemoNavChapter';

export function getStoredDemoChapter() {
  try {
    return sessionStorage.getItem(DEMO_NAV_CHAPTER_KEY);
  } catch {
    return null;
  }
}
